/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppVaultRouteImport } from './routes/_app/vault'
import { Route as AppSwapIndexRouteImport } from './routes/_app/swap/index'
import { Route as AppPoolIndexRouteImport } from './routes/_app/pool/index'
import { Route as AppToolsCreateAccountRouteImport } from './routes/_app/tools/create-account'
import { Route as AppSwapLogsRouteImport } from './routes/_app/swap/logs'
import { Route as AppPoolLogsRouteImport } from './routes/_app/pool/logs'
import { Route as AppPoolCreateMarketRouteImport } from './routes/_app/pool/create-market'
import { Route as AppMiningTradeRouteImport } from './routes/_app/mining/trade'
import { Route as AppMiningLiquidityRouteImport } from './routes/_app/mining/liquidity'
import { Route as AppMiningLendRouteImport } from './routes/_app/mining/lend'
import { Route as AppManageSetupRouteImport } from './routes/_app/manage/setup'
import { Route as AppLendMarketRouteImport } from './routes/_app/lend/market'
import { Route as AppLendAssetsRouteImport } from './routes/_app/lend/assets'
import { Route as AppPoolReduceItemRouteImport } from './routes/_app/pool/reduce/$item'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppVaultRoute = AppVaultRouteImport.update({
  id: '/vault',
  path: '/vault',
  getParentRoute: () => AppRoute,
} as any)
const AppSwapIndexRoute = AppSwapIndexRouteImport.update({
  id: '/swap/',
  path: '/swap/',
  getParentRoute: () => AppRoute,
} as any)
const AppPoolIndexRoute = AppPoolIndexRouteImport.update({
  id: '/pool/',
  path: '/pool/',
  getParentRoute: () => AppRoute,
} as any)
const AppToolsCreateAccountRoute = AppToolsCreateAccountRouteImport.update({
  id: '/tools/create-account',
  path: '/tools/create-account',
  getParentRoute: () => AppRoute,
} as any)
const AppSwapLogsRoute = AppSwapLogsRouteImport.update({
  id: '/swap/logs',
  path: '/swap/logs',
  getParentRoute: () => AppRoute,
} as any)
const AppPoolLogsRoute = AppPoolLogsRouteImport.update({
  id: '/pool/logs',
  path: '/pool/logs',
  getParentRoute: () => AppRoute,
} as any)
const AppPoolCreateMarketRoute = AppPoolCreateMarketRouteImport.update({
  id: '/pool/create-market',
  path: '/pool/create-market',
  getParentRoute: () => AppRoute,
} as any)
const AppMiningTradeRoute = AppMiningTradeRouteImport.update({
  id: '/mining/trade',
  path: '/mining/trade',
  getParentRoute: () => AppRoute,
} as any)
const AppMiningLiquidityRoute = AppMiningLiquidityRouteImport.update({
  id: '/mining/liquidity',
  path: '/mining/liquidity',
  getParentRoute: () => AppRoute,
} as any)
const AppMiningLendRoute = AppMiningLendRouteImport.update({
  id: '/mining/lend',
  path: '/mining/lend',
  getParentRoute: () => AppRoute,
} as any)
const AppManageSetupRoute = AppManageSetupRouteImport.update({
  id: '/manage/setup',
  path: '/manage/setup',
  getParentRoute: () => AppRoute,
} as any)
const AppLendMarketRoute = AppLendMarketRouteImport.update({
  id: '/lend/market',
  path: '/lend/market',
  getParentRoute: () => AppRoute,
} as any)
const AppLendAssetsRoute = AppLendAssetsRouteImport.update({
  id: '/lend/assets',
  path: '/lend/assets',
  getParentRoute: () => AppRoute,
} as any)
const AppPoolReduceItemRoute = AppPoolReduceItemRouteImport.update({
  id: '/pool/reduce/$item',
  path: '/pool/reduce/$item',
  getParentRoute: () => AppRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/vault': typeof AppVaultRoute
  '/lend/assets': typeof AppLendAssetsRoute
  '/lend/market': typeof AppLendMarketRoute
  '/manage/setup': typeof AppManageSetupRoute
  '/mining/lend': typeof AppMiningLendRoute
  '/mining/liquidity': typeof AppMiningLiquidityRoute
  '/mining/trade': typeof AppMiningTradeRoute
  '/pool/create-market': typeof AppPoolCreateMarketRoute
  '/pool/logs': typeof AppPoolLogsRoute
  '/swap/logs': typeof AppSwapLogsRoute
  '/tools/create-account': typeof AppToolsCreateAccountRoute
  '/pool/': typeof AppPoolIndexRoute
  '/swap/': typeof AppSwapIndexRoute
  '/pool/reduce/$item': typeof AppPoolReduceItemRoute
}
export interface FileRoutesByTo {
  '/vault': typeof AppVaultRoute
  '/': typeof AppIndexRoute
  '/lend/assets': typeof AppLendAssetsRoute
  '/lend/market': typeof AppLendMarketRoute
  '/manage/setup': typeof AppManageSetupRoute
  '/mining/lend': typeof AppMiningLendRoute
  '/mining/liquidity': typeof AppMiningLiquidityRoute
  '/mining/trade': typeof AppMiningTradeRoute
  '/pool/create-market': typeof AppPoolCreateMarketRoute
  '/pool/logs': typeof AppPoolLogsRoute
  '/swap/logs': typeof AppSwapLogsRoute
  '/tools/create-account': typeof AppToolsCreateAccountRoute
  '/pool': typeof AppPoolIndexRoute
  '/swap': typeof AppSwapIndexRoute
  '/pool/reduce/$item': typeof AppPoolReduceItemRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/_app/vault': typeof AppVaultRoute
  '/_app/': typeof AppIndexRoute
  '/_app/lend/assets': typeof AppLendAssetsRoute
  '/_app/lend/market': typeof AppLendMarketRoute
  '/_app/manage/setup': typeof AppManageSetupRoute
  '/_app/mining/lend': typeof AppMiningLendRoute
  '/_app/mining/liquidity': typeof AppMiningLiquidityRoute
  '/_app/mining/trade': typeof AppMiningTradeRoute
  '/_app/pool/create-market': typeof AppPoolCreateMarketRoute
  '/_app/pool/logs': typeof AppPoolLogsRoute
  '/_app/swap/logs': typeof AppSwapLogsRoute
  '/_app/tools/create-account': typeof AppToolsCreateAccountRoute
  '/_app/pool/': typeof AppPoolIndexRoute
  '/_app/swap/': typeof AppSwapIndexRoute
  '/_app/pool/reduce/$item': typeof AppPoolReduceItemRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/vault'
    | '/lend/assets'
    | '/lend/market'
    | '/manage/setup'
    | '/mining/lend'
    | '/mining/liquidity'
    | '/mining/trade'
    | '/pool/create-market'
    | '/pool/logs'
    | '/swap/logs'
    | '/tools/create-account'
    | '/pool/'
    | '/swap/'
    | '/pool/reduce/$item'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/vault'
    | '/'
    | '/lend/assets'
    | '/lend/market'
    | '/manage/setup'
    | '/mining/lend'
    | '/mining/liquidity'
    | '/mining/trade'
    | '/pool/create-market'
    | '/pool/logs'
    | '/swap/logs'
    | '/tools/create-account'
    | '/pool'
    | '/swap'
    | '/pool/reduce/$item'
  id:
    | '__root__'
    | '/_app'
    | '/_app/vault'
    | '/_app/'
    | '/_app/lend/assets'
    | '/_app/lend/market'
    | '/_app/manage/setup'
    | '/_app/mining/lend'
    | '/_app/mining/liquidity'
    | '/_app/mining/trade'
    | '/_app/pool/create-market'
    | '/_app/pool/logs'
    | '/_app/swap/logs'
    | '/_app/tools/create-account'
    | '/_app/pool/'
    | '/_app/swap/'
    | '/_app/pool/reduce/$item'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/vault': {
      id: '/_app/vault'
      path: '/vault'
      fullPath: '/vault'
      preLoaderRoute: typeof AppVaultRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/swap/': {
      id: '/_app/swap/'
      path: '/swap'
      fullPath: '/swap/'
      preLoaderRoute: typeof AppSwapIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/pool/': {
      id: '/_app/pool/'
      path: '/pool'
      fullPath: '/pool/'
      preLoaderRoute: typeof AppPoolIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/tools/create-account': {
      id: '/_app/tools/create-account'
      path: '/tools/create-account'
      fullPath: '/tools/create-account'
      preLoaderRoute: typeof AppToolsCreateAccountRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/swap/logs': {
      id: '/_app/swap/logs'
      path: '/swap/logs'
      fullPath: '/swap/logs'
      preLoaderRoute: typeof AppSwapLogsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/pool/logs': {
      id: '/_app/pool/logs'
      path: '/pool/logs'
      fullPath: '/pool/logs'
      preLoaderRoute: typeof AppPoolLogsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/pool/create-market': {
      id: '/_app/pool/create-market'
      path: '/pool/create-market'
      fullPath: '/pool/create-market'
      preLoaderRoute: typeof AppPoolCreateMarketRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/mining/trade': {
      id: '/_app/mining/trade'
      path: '/mining/trade'
      fullPath: '/mining/trade'
      preLoaderRoute: typeof AppMiningTradeRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/mining/liquidity': {
      id: '/_app/mining/liquidity'
      path: '/mining/liquidity'
      fullPath: '/mining/liquidity'
      preLoaderRoute: typeof AppMiningLiquidityRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/mining/lend': {
      id: '/_app/mining/lend'
      path: '/mining/lend'
      fullPath: '/mining/lend'
      preLoaderRoute: typeof AppMiningLendRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/manage/setup': {
      id: '/_app/manage/setup'
      path: '/manage/setup'
      fullPath: '/manage/setup'
      preLoaderRoute: typeof AppManageSetupRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/lend/market': {
      id: '/_app/lend/market'
      path: '/lend/market'
      fullPath: '/lend/market'
      preLoaderRoute: typeof AppLendMarketRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/lend/assets': {
      id: '/_app/lend/assets'
      path: '/lend/assets'
      fullPath: '/lend/assets'
      preLoaderRoute: typeof AppLendAssetsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/pool/reduce/$item': {
      id: '/_app/pool/reduce/$item'
      path: '/pool/reduce/$item'
      fullPath: '/pool/reduce/$item'
      preLoaderRoute: typeof AppPoolReduceItemRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppVaultRoute: typeof AppVaultRoute
  AppIndexRoute: typeof AppIndexRoute
  AppLendAssetsRoute: typeof AppLendAssetsRoute
  AppLendMarketRoute: typeof AppLendMarketRoute
  AppManageSetupRoute: typeof AppManageSetupRoute
  AppMiningLendRoute: typeof AppMiningLendRoute
  AppMiningLiquidityRoute: typeof AppMiningLiquidityRoute
  AppMiningTradeRoute: typeof AppMiningTradeRoute
  AppPoolCreateMarketRoute: typeof AppPoolCreateMarketRoute
  AppPoolLogsRoute: typeof AppPoolLogsRoute
  AppSwapLogsRoute: typeof AppSwapLogsRoute
  AppToolsCreateAccountRoute: typeof AppToolsCreateAccountRoute
  AppPoolIndexRoute: typeof AppPoolIndexRoute
  AppSwapIndexRoute: typeof AppSwapIndexRoute
  AppPoolReduceItemRoute: typeof AppPoolReduceItemRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppVaultRoute: AppVaultRoute,
  AppIndexRoute: AppIndexRoute,
  AppLendAssetsRoute: AppLendAssetsRoute,
  AppLendMarketRoute: AppLendMarketRoute,
  AppManageSetupRoute: AppManageSetupRoute,
  AppMiningLendRoute: AppMiningLendRoute,
  AppMiningLiquidityRoute: AppMiningLiquidityRoute,
  AppMiningTradeRoute: AppMiningTradeRoute,
  AppPoolCreateMarketRoute: AppPoolCreateMarketRoute,
  AppPoolLogsRoute: AppPoolLogsRoute,
  AppSwapLogsRoute: AppSwapLogsRoute,
  AppToolsCreateAccountRoute: AppToolsCreateAccountRoute,
  AppPoolIndexRoute: AppPoolIndexRoute,
  AppSwapIndexRoute: AppSwapIndexRoute,
  AppPoolReduceItemRoute: AppPoolReduceItemRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
